/**
 * Sofa-Finder scoring engine. Scores (doesn't hard-filter) every product in
 * sofa-finder-data.json against the 5 answers so the quiz never dead-ends on
 * zero results. Every "why" line shown to the customer is built from a real
 * matched attribute in that product's own data -- nothing invented.
 */
(function () {
  var root = document.getElementById('SofaFinder');
  if (!root) return;

  var steps = Array.prototype.slice.call(root.querySelectorAll('.sf-step[data-step]'));
  var order = ['0', '1', '2', '3', '4', 'result'];
  var progressWrap = document.getElementById('SfProgress');
  var backBtn = document.getElementById('SfBack');
  var restartBtn = document.getElementById('SfRestart');
  var resultsEl = document.getElementById('SfResults');

  var answers = {};
  var current = 0;
  var dataUrl = root.getAttribute('data-json') || '';
  var pool = null;
  var startBtn = document.getElementById('SfStart');

  order.slice(0, -1).forEach(function () {
    var seg = document.createElement('div');
    seg.className = 'sf-progress__seg';
    progressWrap.appendChild(seg);
  });
  var segs = progressWrap.querySelectorAll('.sf-progress__seg');

  function showStep(i) {
    current = i;
    steps.forEach(function (s) {
      s.classList.toggle('is-active', s.getAttribute('data-step') === order[i]);
    });
    segs.forEach(function (seg, idx) { seg.classList.toggle('is-done', idx < i); });
    backBtn.hidden = i === 0;
    if (order[i] === 'result') computeResults();
  }

  root.querySelectorAll('.sf-options').forEach(function (group) {
    var key = group.getAttribute('data-question');
    group.querySelectorAll('.sf-option').forEach(function (btn) {
      btn.addEventListener('click', function () {
        answers[key] = btn.getAttribute('data-value');
        showStep(current + 1);
      });
    });
  });

  backBtn.addEventListener('click', function () {
    if (current > 0) showStep(current - 1);
  });

  restartBtn.addEventListener('click', function () {
    answers = {};
    showStep(0);
  });

  if (startBtn) {
    startBtn.addEventListener('click', function () {
      root.classList.remove('sf-intro-active');
      showStep(0);
    });
  }

  function inRange(value, rangeStr) {
    var parts = rangeStr.split(',').map(Number);
    return value >= parts[0] && value <= parts[1];
  }

  var STYLE_LINES = {
    soft: ['BonBon3', 'Choice'],
    modular: ['Bard', 'CasCais', 'Matacao3'],
    lounge: ['Clooods', 'Diagon'],
  };

  var STYLE_REASON = {
    soft: 'Seduta morbida e accogliente',
    modular: 'Modulare ed espandibile',
    lounge: 'Seduta profonda, stile lounge',
  };

  // Slovenian has four plural forms and the seat count drives all four
  // (1 sedez, 2 sedeza, 3-4 sedezi, 5+ sedezev). DE could concatenate a
  // single word; here the number picks the form. Same modulo-100 rule
  // already used for the review counts and the assembly steps.
  function seats(n) {
    var r = n % 100;
    if (r === 1) return n + ' posto';
    if (r === 2) return n + ' posti';
    if (r === 3 || r === 4) return n + ' posti';
    return n + ' posti';
  }

  function score(p) {
    var s = 0;
    var reasons = [];

    if (answers.persons && inRange(p.persons, answers.persons)) {
      s += 3;
      reasons.push(seats(p.persons));
    } else if (answers.persons) {
      var want = answers.persons.split(',').map(Number);
      s -= Math.abs(p.persons - want[0]) * 0.4;
    }

    if (answers.width && inRange(p.width, answers.width)) {
      s += 3;
      reasons.push(p.width + ' cm di larghezza');
    } else if (answers.width) {
      var wantW = answers.width.split(',').map(Number);
      s -= Math.abs(p.width - wantW[0]) * 0.02;
    }

    if (answers.sleep === 'yes') {
      s += p.sleep ? 4 : -3;
      if (p.sleep) reasons.push('Con funzione letto');
    } else if (answers.sleep === 'maybe' && p.sleep) {
      s += 1.5;
      reasons.push('Con funzione letto');
    }

    if (answers.storage === 'yes') {
      s += p.storage ? 2 : -1;
      if (p.storage) reasons.push('Spazio contenitore extra');
    }

    if (answers.style && STYLE_LINES[answers.style] && STYLE_LINES[answers.style].indexOf(p.line) !== -1) {
      s += 1.5;
      reasons.push(STYLE_REASON[answers.style]);
    }

    if (!reasons.length && p.covers) reasons.push('Fodere rimovibili e lavabili');
    if (!reasons.length) reasons.push(seats(p.persons) + ', ' + p.width + ' cm di larghezza');

    return { score: s, reasons: reasons.slice(0, 3) };
  }

  function computeResults() {
    resultsEl.innerHTML = '<p>Carico i consigli…</p>';
    var ready = pool ? Promise.resolve(pool) : fetch(dataUrl).then(function (r) { return r.json(); });
    ready.then(function (data) {
      pool = data;
      var ranked = data
        .map(function (p) { var sc = score(p); return Object.assign({}, p, sc); })
        .sort(function (a, b) { return b.score - a.score; })
        .slice(0, 3);

      resultsEl.innerHTML = '';
      ranked.forEach(function (p, i) {
        var a = document.createElement('a');
        a.href = '/products/' + p.handle;
        a.className = 'sf-card' + (i === 0 ? ' sf-card--top' : '');
        a.innerHTML =
          '<img class="sf-card__img" src="' + p.image + '&width=600" alt="' + p.title + '" loading="lazy">' +
          '<div>' +
          '<div class="sf-card__badge">' + (i === 0 ? 'Consiglio migliore' : 'Alternativa') + '</div>' +
          '<h3 class="sf-card__title">' + p.title + '</h3>' +
          '<p class="sf-card__why">' + p.reasons.join(' · ') + '</p>' +
          '</div>';
        resultsEl.appendChild(a);
      });
    });
  }

  if (!startBtn) showStep(0);
})();
